import { Pipe, PipeTransform } from '@angular/core';
import { CustomModelAction } from 'app/automations/automations-models';
import IconsHelper from '../helpers/icons-helper';

@Pipe({
  name: 'getAutomationIcons',
  standalone: false,
})
export class GetAutomationIcons implements PipeTransform {
  constructor() {}

  transform(action: CustomModelAction) {
    return IconsHelper.getLogoPath(action.nameAction);
  }
}

@Pipe({
  name: 'getColorAutomationIcons',
  standalone: false,
})
export class GetColorAutomationIcons implements PipeTransform {
  constructor() {}

  transform(action: any) {
    const nameAction = action.name || action.nameAction || action;
    if (
      typeof action === 'string' &&
      (action.endsWith('http.svg') || action.endsWith('apsis.png') || action.toLowerCase().includes('klaviyo'))
    ) {
      return true;
    } else if (
      typeof action === 'object' &&
      (nameAction === 'Apsis' ||
        nameAction === 'IfUrl' ||
        nameAction === 'ApsisOne' ||
        nameAction === 'Triggerbee' ||
        nameAction === 'Klaviyo' ||
        nameAction === 'TriggerbeeProfile' ||
        nameAction === 'TriggerbeeExecuteWebhook' ||
        nameAction === 'TriggerbeeSendMail')
    ) {
      return true;
    } else {
      return false;
    }
  }
}
